import { AfterViewInit, Component, ContentChild, ContentChildren, Input, OnInit, QueryList } from '@angular/core';
import { TableHeadComponent } from './table-head/table-head.component';
import { TableHeaderComponent } from './table-header/table-header.component';
import { TableRowComponent } from './table-row/table-row.component';

@Component({
  selector: 'ff-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, AfterViewInit {

  @Input() class: string;

  @ContentChild(TableHeadComponent) headTemplate: TableHeadComponent;
  public headersTemplates: QueryList<TableHeaderComponent>;
  @ContentChildren(TableHeaderComponent, {descendants: true}) headers: QueryList<TableHeaderComponent>;

  @ContentChildren(TableRowComponent) rowTemplates: QueryList<TableRowComponent>;
  
  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.headersTemplates = this.headers);
  }

}
